import { createIcon } from '@chakra-ui/icons'

// using `path`
export const MongooseIcon = createIcon({
  displayName: 'MongooseIcon',
  viewBox:"0, 0, 3550,2550",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g transform="translate(0.00000,2500.000000) scale(0.200000,-0.200000)"
    fill="#000000" stroke="none">
<path d="M8469 10849 c-167 -7 -449 -52 -449 -71 0 -8 199 -108 214 -108 14 0
245 -116 296 -148 67 -43 115 -82 101 -82 -9 0 -246 92 -336 131 -73 31 -377
122 -525 157 -80 19 -114 26 -250 51 -201 37 -437 39 -540 5 -147 -48 -180
-107 -180 -325 0 -120 6 -171 32 -279 11 -47 43 -150 58 -185 4 -11 18 -45 30
-75 12 -30 48 -107 80 -170 179 -357 447 -655 825 -917 119 -82 443 -238 573
-275 33 -9 44 -28 17 -28 -30 0 -304 76 -360 100 -11 5 -40 17 -65 26 -195 79
-444 242 -650 427 -226 202 -408 453 -529 727 -79 179 -133 388 -146 570 -8
104 -16 129 -43 128 -9 0 -94 3 -188 8 -255 11 -604 -17 -949 -77 -660 -113
-1372 -374 -2105 -772 -124 -68 -183 -101 -361 -207 -14 -8 -58 -35 -98 -60
-40 -25 -87 -53 -104 -64 -38 -22 -457 -308 -507 -346 -19 -14 -71 -53 -115
-85 -199 -148 -632 -503 -657 -539 -12 -18 7 -27 33 -18 13 5 47 12 74 16 28
4 100 23 160 43 61 19 126 39 145 44 148 35 208 47 295 60 39 5 97 14 130 19
406 60 600 75 781 61 393 -32 769 -99 984 -176 161 -58 489 -236 633 -343 83
-63 351 -331 410 -412 46 -64 97 -120 109 -120 4 0 9 204 10 453 l3 452 526 3
c414 2 529 -1 536 -10 10 -13 34 -56 113 -203 75 -141 112 -209 135 -250 12
-22 40 -74 63 -115 22 -41 63 -117 91 -169 28 -52 51 -96 51 -98 0 -9 41 -63
48 -63 4 0 14 15 21 33 8 17 29 57 46 87 18 30 50 89 72 130 22 41 52 98 68
125 44 79 90 165 128 235 19 36 49 92 67 125 18 33 44 80 58 105 13 25 29 51
34 58 8 9 126 12 552 10 l541 -3 3 -882 c2 -697 5 -883 15 -883 6 1 46 24 87
53 58 41 83 66 110 112 61 105 234 270 350 334 140 78 291 135 450 170 160 34
207 39 570 52 663 23 761 27 766 32 3 3 -6 29 -19 59 -14 29 -38 83 -55 119
-63 137 -63 183 3 250 45 47 161 88 360 128 33 7 74 16 91 22 17 5 38 9 47 9
25 0 224 49 266 65 29 12 185 46 371 82 81 16 291 58 465 93 110 22 225 45
255 51 30 6 73 15 95 19 22 5 51 11 65 13 14 3 84 17 155 32 72 15 144 29 161
31 50 5 427 96 514 124 138 45 179 63 266 122 94 64 120 99 213 285 103 207
118 242 147 329 45 139 42 192 -15 250 -40 40 -126 81 -189 90 -47 6 -53 4
-76 -21 -14 -15 -26 -33 -26 -39 0 -9 -16 -53 -61 -161 -4 -11 -13 -38 -20
-60 -6 -22 -18 -53 -25 -70 -13 -28 -14 -23 -9 55 5 77 18 142 47 240 5 19 12
51 15 71 l5 36 -104 42 c-108 45 -201 84 -255 108 -18 7 -63 25 -100 39 -38
14 -84 32 -103 41 -36 16 -70 30 -105 44 -67 26 -301 106 -500 169 -54 17
-369 112 -400 121 -64 17 -111 30 -140 39 -16 4 -55 15 -85 23 -176 49 -222
61 -285 79 -38 11 -86 24 -105 28 -19 5 -71 17 -115 28 -77 19 -400 94 -575
134 -47 11 -103 24 -125 29 -22 5 -62 13 -90 18 -27 5 -84 16 -125 25 -41 8
-129 25 -195 36 -66 12 -145 26 -175 31 -276 50 -295 53 -790 108 -305 35
-715 64 -815 59 -16 0 -105 -4 -196 -9z m-1156 -493 c264 -86 521 -203 697
-317 140 -91 314 -236 361 -301 l20 -27 -38 15 c-21 9 -65 28 -98 44 -176 82
-195 89 -195 71 0 -5 41 -71 90 -145 50 -75 90 -141 90 -147 0 -5 -19 3 -42
19 -90 62 -301 151 -313 133 -3 -5 62 -88 145 -185 82 -97 150 -180 150 -186
0 -15 -16 -13 -92 15 -78 28 -98 31 -98 12 0 -13 169 -242 236 -321 19 -22 34
-43 34 -48 0 -24 -234 129 -400 261 -237 190 -466 445 -587 656 -99 172 -133
265 -133 367 0 60 3 72 25 93 13 14 29 25 35 25 6 0 56 -15 113 -34z m3157
-356 c96 -17 227 -40 290 -51 63 -11 140 -24 170 -29 30 -6 73 -14 95 -19 22
-5 65 -14 95 -21 99 -22 123 -27 285 -65 174 -41 212 -49 265 -60 45 -9 90
-26 90 -34 0 -3 -33 -22 -73 -43 -82 -41 -99 -44 -437 -57 -230 -10 -353 -7
-465 11 -226 35 -343 99 -434 237 -32 47 -53 61 -126 80 -27 8 -68 19 -90 26
-22 7 -60 18 -84 25 -72 19 -31 30 114 30 100 0 170 -7 305 -30z m1203 -1397
c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-43 -12 c0 -5 -12 -12
-27 -15 -31 -8 -153 -43 -193 -56 -14 -5 -59 -19 -100 -31 -103 -30 -353 -112
-420 -138 -126 -48 -422 -206 -464 -248 -62 -61 -81 -127 -72 -253 3 -53 10
-120 16 -149 12 -63 5 -80 -19 -49 -24 31 -75 143 -90 198 -8 25 -17 58 -22
74 -18 57 -11 124 17 165 38 58 174 151 334 228 76 37 297 113 500 173 41 12
86 26 100 30 144 49 440 96 440 71z m-3163 -67 c-3 -3 -12 -4 -19 -1 -8 3 -5
6 6 6 11 1 17 -2 13 -5z"/>
<path d="M6370 6590 l0 -700 498 0 c374 0 501 3 510 12 15 15 18 1388 3 1388
-5 0 -12 -8 -15 -17 -4 -9 -113 -180 -243 -380 -206 -316 -263 -393 -263 -354
0 7 -341 542 -428 671 -10 14 -24 37 -31 53 -8 15 -18 27 -23 27 -4 0 -8 -315
-8 -700z"/>
</g>
  ),
})
